(function () {
  'use strict';

  angular.module('ringbaPortal').controller('ZendeskSSOController', ZendeskSSOController);

  function ZendeskSSOController(
    $http,
    $q,
    $state,
    ngAuthSettings,
    accountsService,
    utils
  ) {

    const vm = this;
    vm.$onChanges = onChanges;

    vm.jwtToken = '';
    vm.accountsService = accountsService;
    vm.serviceBaseUrl = ngAuthSettings.apiServiceBaseUri;

    function onChanges () {
      vm.init();
    }

    vm.init = async function () {
      try {
        const response = await vm.getJwtToken();
        const { token } = response;
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', 'https://ringba.zendesk.com/access/jwt?return_to=https://ringba.zendesk.com/hc/en-us/requests');
        form.setAttribute('target', '_blank');

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'jwt';
        input.value = token;

        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

        $state.go('dashboard.main');
      } catch (e) {
        await $state.go('dashboard.main');
        utils.errorHandler(e);
      }
    };

    vm.getJwtToken = function () {
      const deferred = $q.defer();

      $http.get(`${vm.serviceBaseUrl}${vm.accountsService.currentAccountId}/sso/zendesk`).then(function (response) {
        // Success callback
        deferred.resolve(response.data);
      }, function (error) {
        // Error callback
        deferred.reject(error);
      });

      return deferred.promise;
    };

  }
})();
